// Import: Middleware Action & Custom Types
import {
    CLEAN_BACKOFFICE_STATUS,
    CLEAN_BACKOFFICE_STATUS_ERROR,
} from "_models/redux/types";

// Action function
export const cleanBackofficeStatusAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_BACKOFFICE_STATUS,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_BACKOFFICE_STATUS_ERROR,
            payload: undefined,
        });
    }
};
